import React from "react";
import styles from "./politica-inversion.module.css";
import * as Constantes from "../../../../utils/constantes";

const PoliticaInversion = () => {
    const abrirPoliticaInversion = () => {
        window.open(Constantes.URL_POLITICA_INVERSION)
    }

    return (
        <div className={styles.btn_politica_inversion} onClick={() => abrirPoliticaInversion()}>
            <span className={styles.spn_politica_inversion}>Política de inversión</span>
        </div>
    )
}

export default PoliticaInversion;